<template>
  <div class="card">
    <div class="bg-primary p-1 text-white rounded-top">
      ตัวอย่างหน้าแสดงผล
    </div>

    <div class="p-1">
      <!-- Header Show -->
      <div
        class="prelative"
        :style="{ background: data.bg ? `url(${data.bg})` : '' }"
      >
        <div
          class="card-show p-25"
          :style="{ background: data.nav_color ? data.nav_color.hex : '' }"
        >
          <div
            class="d-flex justify-content-between align-items-center p-50 x-header navbar navbar-expand-lg -anon"
          >
            <div class="d-flex justify-content-start align-items-center">
              <button
                v-b-toggle.sidebar-right
                type="button"
                class="btn bg-transparent p-0 x-hamburger js-hamburger-toggle"
              >
                <span />
                <span />
                <span />
              </button>
              <div>
                <a
                  routerlink="/"
                  class="navbar-brand"
                  href="/"
                >
                  <img
                    alt=" รวมคาสิโนออนไลน์ บาคาร่าสด สล็อต กีฬา และเครดิตฟรี"
                    height="50"
                    :src="
                      data.logo
                        ? data.logo
                        : 'https://wallet.power100th.com/logo/pw100.svg'
                    "
                  >
                </a>
              </div>
            </div>

            <ul class="nav -menu-wrapper">
              <li class="nav-item ng-star-inserted">
                <router-link
                  routerlinkactive="-active"
                  :to="{ name: 'lucky-wheel' }"
                  :class="{ '-active': $route.name === 'lucky-wheel' }"
                  class="nav-link -promotion"
                >
                  <div class="-img-wrapper">
                    <img
                      src="@/assets/newImg/wheel.png"
                      alt="Menu icon promotion"
                      width="30"
                      height="30"
                      class="-icon"
                    >
                  </div>
                  <div class="-text">
                    หมุนกงล้อ
                  </div>
                </router-link>
              </li>
              <li class="nav-item ng-star-inserted">
                <router-link
                  routerlinkactive="-active"
                  :to="{ name: 'deposit-fixed' }"
                  :class="{ '-active': $route.name === 'deposit-fixed' }"
                  class="nav-link -promotion"
                >
                  <div class="-img-wrapper">
                    <img
                      src="@/assets/newImg/depo.png"
                      alt="Menu icon promotion"
                      width="30"
                      height="30"
                      class="-icon"
                    >
                  </div>
                  <div class="-text">
                    ฝากประจำ
                  </div>
                </router-link>
              </li>
              <li class="nav-item ng-star-inserted">
                <router-link
                  routerlinkactive="-active"
                  :to="{ name: 'invite-friend' }"
                  :class="{ '-active': $route.name === 'invite-friend' }"
                  class="nav-link -promotion"
                >
                  <div class="-img-wrapper">
                    <img
                      src="@/assets/newImg/affiliate.png"
                      alt="Menu icon promotion"
                      width="30"
                      height="30"
                      class="-icon"
                    >
                  </div>
                  <div class="-text">
                    สร้างรายได้
                  </div>
                </router-link>
              </li>
              <li class="nav-item ng-star-inserted">
                <router-link
                  routerlinkactive="-active"
                  class="nav-link -promotion"
                  :class="{ '-active': $route.name === 'promotions' }"
                  :to="{ name: 'promotions' }"
                >
                  <div class="-img-wrapper">
                    <img
                      src="@/assets/newImg/ic-header-menu-promotion.png"
                      alt="Menu icon promotion"
                      width="30"
                      height="30"
                      class="-icon"
                    >
                  </div>
                  <div class="-text">
                    โปรโมชั่น
                  </div>
                </router-link>
              </li>
            </ul>

            <div class="-profile-container">
              <div class="js-ez-logged-sidebar -btn-mobile-wrapper">
                <div class="-inner-wrapper">
                  <a class="text-decoration-none">
                    <div class="-profile-name">power1231231231</div>
                  </a>

                  <div class="-balance-container">
                    <div class="-user-balance js-user-balance f-sm-6 f-7">
                      <div
                        tabindex="0"
                        class="-inner-box-wrapper ng-star-inserted"
                      >
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAVCAYAAABYHP4bAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVVSURBVHgBlVVbiJVVFP7W3vv/zzn/OXO1cUYbL9OYgjaVVkRZaJRhvgT5EEIPqRAUEQhGRUQngrIXJXvpoRAkBe2CBBb6UGAiFaQUXlDzMurozHjmdm7/de/dOmccHU0zNyz2Puf/9/rW+ta31k+4Ydk8RGHp3UtaOnKzrXDuElJKQVIbwBdEF+BiP939RwF3uGjyj96v1dNt3d0bMq2NC0EkAYG60eRdGpD8FXC+gsYemrX79B0Bnd+plrd2zd3mtXe0sCMaB3ENtBPDUAomsiAdwFEpSIefK4KQg7xvZcAN1Ll16LZAh/NwW3ruOjH90cUz6yAk2OlUDTObkIyFoEBBVwnRqA//cg62EiPbIpBtV5Apfl8e58DeoPbP9t4SyLLLc5/O/KhpYcO6prkPp+qZyGkJaJaFPqOAmMAvcfXGbxiuVlzSKJ4HooJGU5dEUzdfUhyQ2oygnKcZm/x/AfVunLOAHL2v5YkuNzd9Qa4O5PRUEJ7wYAOqA9grIDee44rFyN+az4QZzzKVmVp223Cxspbuy0eTgYQxyTPairRN4EA0cTaNHHVUQVIk6BBI2DTf4bOVs4DWNUDb60DTSiDTQ5i5RjHxFqd3acShBnkvobN9uz2cd68D0kRzLJQXlQNrKcOKyvLfsQsT46rpcSN3HnPg1gJhplqBxqVAegFswwKF3DRW1G6uK3GG6RfQOWv9dUCQwkdikZQSZWLmRdTYczwYPteyQDPQsBjIPQ5TOcUZsriCc9D9XPegj2MaAJkS05114DYo9O8zEGkOKP2+Hf581TUg4R21QjGQR+HQGZaGx/R5yqY6dS0LG/sMxnTKZlb3AEzxGGc3DOnG0EP7Yf3TsMYbp9f1JMJ+VueYZjDXypYP7cnnUnUgt61xL0k5aI2USSkyiT/E9KUEefeyKlJW6H7Y4V+AsJdZy4FCzirgHjVViKQXKPwE8o9dobhGKfstnmJRKNZFtlu7S56vAclN354vvfXyI9O17z8G7Uk3Z4zKdRjIBhkIbiv/JIGzEmaMfV+CoFKdLhv1s7xLPEDYueWymIT3ZFyOIjcGUc0gOAtTPilk21/fqDpauvETIrXK+H5HfJngNJ0zonFelM42u4FZruXF7wTCS8QNhSTyuZ/ZMU8omcpck/tEr9U7k614iH8zcFyc+dr8Nu/qCBr8YfWLQtsvlVJZKaIoN/8eQiolEI+KJCiTqZw1Mi4KWRPV1X66YhbXzqnOBKkc1+mk5OIh8qtHq319i8UE0NQVW3bIVHqjDqvcp2V3+LcDTjx0QVszpFV03DqqKhJBNtDW6oRlWpN4zWrSr595p5xGZmqM8LiA5uFgAiSVsWLh/KgvJ2t93bLW353GtImLw08KCRo8clAwRdaZOptn9phRZkQoFZMhw/Rwak6aN0FQWQtvWgzXTeD/mWap1ieKTuKkdHFw54zV8Y+Em6yhXcs+qBYuvy0z1h25cIGDdHXz3IVo7GjWIuglSoocoBG45eKsYx0PnR0o9Z0dfWjRevTeFKhW0r7ti57SYemLOCx2lQdH4TQnHHDWTumerbMdnVo6/BlMRhSZKg/E2NTv8QDS2mTCSpAUThfkWH/1vQfeST6uPSP8xzqwsTMzJV1+Mw7Kr5oo6cg1cEmqgMd7Q7MTuS3tktMNDWVtHIUyrFS0PzyaKQ+MGB2Ee0jptT3vYuC2QBPr4Ga0eRBrXGFWZtK4n1hXtbZRaYcJbOZhm+Ovg484ihGFYRgn+nsk/isL8xid8PG/gCbWz3moB7vQwy20IpOiRZGd0krpdlQDgzCIWMrhkSgItuwYKRzK52Em3/0HGzubiBqlP6cAAAAASUVORK5CYII="
                          alt="customer image"
                          width="26"
                          height="21"
                          class="img-fluid -ic-coin"
                        ><span
                          id="customer-balance"
                          tabindex="0"
                        ><span class="-amount"> 0.00 </span></span>
                      </div>
                      <button
                        id="btn-customer-balance-reload"
                        type="button"
                        class="-btn-balance"
                      >
                        <i class="fas fa-sync-alt f-9 ic" />
                      </button>
                    </div>
                  </div>
                </div>
                <a href="/profile">
                  <div class="x-profile-image">
                    <img
                      src="https://wallet.power100th.com/img/profile.77f5794e.jpg"
                      alt="profile"
                      width="40px"
                      height="40px"
                      class="rounded-circle border border-2"
                      style="vertical-align: initial"
                    >
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Slider Show -->
        <div>
          <swiper
            class="swiper-autoplay"
            :options="swiperOptions"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          >
            <swiper-slide
              v-for="data in data.slides"
              :key="data.img"
            >
              <b-img
                :src="data"
                fluid
              />
            </swiper-slide>
          </swiper>
        </div>

        <!-- Notify Show -->
        <div
          class="marq d-flex align-items-center"
          style="background: #1b2341"
          :style="{
            background: data.announce_color ? data.announce_color.hex : '',
          }"
        >
          <div class="ic-txt">
            <i class="fas fa-bullhorn" />
          </div>

          <marquee
            behavior=""
            direction=""
            :style="{
              color: data.announce_text_color
                ? data.announce_text_color.hex
                : '',
            }"
          >
            ... ยินดีต้อนรับสมาชิกเก่าและสมาชิกใหม่ สู่การอัพเกรดไปอีกขั้น
            ของวงการเว็บคาสิโนออนไลน์
            ด้วยการพัฒนาดีไซน์และรูปแบบการเล่นที่ทันสมัยรวดเร็วและตอบสนองการใช้งานได้มากกว่า
            ด้วยการเดิมพันที่รวดเร็ว ระบบการจ่ายเงินรางวัลที่รวดเร็วที่สุด
            ระบบการฝาก-ถอนอัตโนมัติ พร้อมทีมงานดูแลซัพพอตตลอด 24 ชั่วโมง
            มาพร้อมเกมส์ใหม่ ระบบแนะนำสูงสุด 12% และโปรโมชั่นพิเศษมากมาย
            ภายใต้การบริหารโดยทีมงานมืออาชีพ
            ร่วมสนุกและทายผลไปกับเราได้ตั้งแต่วันนี้ power100th.com
            ขอบคุณพระคุณครับ / ค่ะ ..
          </marquee>
        </div>
        <div
          class="bg-mais"
          style="
            background-image: url('https://wallet.power100th.com/index-bg.webp') !important;
          "
        />
        <div class="ng-star-inserted">
          <div class="-games-provider-wrapper">
            <div
              class="-menu-index-page"
              :style="{
                background: data.game_color ? data.game_color.hex : '',
              }"
              style="position: relative; overflow: hidden"
            >
              <div class="sticksy-dummy-node">
                <div class="x-menu-provider js-tab-menu-provider">
                  <nav
                    id="navbarCategory"
                    class="naver-menu"
                  >
                    <ul
                      class="naver naver-pillser js-menu-container -naver-menu-container"
                    >
                      <li
                        v-for="item in gameListOp"
                        :key="item.id"
                        class="naver-item ng-star-inserted"
                      >
                        <button
                          class="naver-linker"
                          :style="{
                            background: data.game_button_color
                              ? data.game_button_color.hex
                              : '',
                          }"
                        >
                          <img
                            :alt="item.alt"
                            width="55"
                            height="55"
                            class="img-fluid -ic-menu"
                            :src="item.icon"
                          >
                          <div class="-text-provider-wrapper">
                            <div class="-text-naver-menu -title-mobile">
                              {{ item.name_th }}
                            </div>
                          </div>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <div class="-games-index-page">
              <div
                class="x-category-provider js-game-scroll-container js-game-container"
              >
                <div class="-games-list-container containerer">
                  <div class="x-hot-games-container">
                    <div class="ng-star-inserted">
                      <div
                        class="x-category-provider js-game-scroll-container js-game-container"
                      >
                        <div>
                          <div class="-bottom-paragraph">
                            <img
                              :src="
                                data.logo
                                  ? data.logo
                                  : 'https://wallet.power100th.com/logo/pw100.svg'
                              "
                              alt="logo-power45"
                              width="200"
                            >
                            <h3 class="-text mt-2">
                              <span class="-highlight">Power45TH</span>
                              เว็บที่ให้บริการคาสิโนออนไลน์เต็มรูปแบบ
                              <br>
                              ทั้งสล็อตออนไลน์ คาสิโนสด บาคาร่าสด เกมแทงปลา
                              เกมกีฬา ฯลฯ
                            </h3>
                            <p class="-text -paragraph -h3">
                              สามารถทำการฝาก-ถอนได้ตลอด 24 ชั่วโมง ด้วยระบบออโต้
                              ทั้งสะดวก
                              รวดเร็วทันใจเป็นอย่างมากเหมาะสำหรับผู้ที่ชื่นชอบการเดิมพันในรูปแบบของเกมการพนันออนไลน์อันดับ
                              1 ในปี 2022
                            </p>
                          </div>
                        </div>

                        <div class="-games-list-container container">
                          <nav
                            id="navbarProvider"
                            class="naver-menu"
                          >
                            <ul class="nav naver-pillser">
                              <li
                                v-for="games in gameList"
                                :key="games.id"
                                class="naver-item -game-casino-macro-container ng-star-inserted"
                              >
                                <div
                                  v-if="games.type === 'FISHING'"
                                  class="x-game-list-item-macro js-game-list-toggle -big"
                                >
                                  <div class="-inner-wrapper">
                                    <img
                                      class="-cover-img img-fluid ls-is-cached lazyloaded"
                                      :src="games.img"
                                      :alt="games.name"
                                    >
                                    <div class="-overlay">
                                      <div class="-overlay-inner">
                                        <div class="-wrapper-container">
                                          <a
                                            class="-btn -btn-play js-account-approve-aware"
                                          ><i class="fas fa-play" /><span
                                            class="-text-btn"
                                          >เข้าเล่น</span></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="-title text-center">
                                    444
                                  </div>
                                </div>

                                <div
                                  v-else
                                  class="x-game-list-item-macro js-game-list-toggle -big"
                                >
                                  <div class="-inner-wrapper">
                                    <img
                                      class="-cover-img bg-back img-fluid ls-is-cached lazyloaded"
                                      :src="`/games/`"
                                      :alt="games.productName"
                                    >
                                    <div class="-overlay">
                                      <div class="-overlay-inner">
                                        <div class="-wrapper-container">
                                          <a
                                            class="-btn -btn-play js-account-approve-aware"
                                          ><i class="fas fa-play" /><span
                                            class="-text-btn"
                                          >เข้าเล่น</span></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="-title text-center">
                                    44
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Show -->
        <div class="-main-footer-container js-replace-main-footer-container">
          <div>
            <div class="x-footer">
              <div class="container-fluid -footer-wrapper">
                <div class="-footer-inner-wrapper">
                  <div class="-describe-wrapper">
                    <div class="-content-wrapper">
                      <h4
                        class="-title"
                        :style="{
                          color: data.title_color ? data.title_color.hex : '',
                        }"
                      >
                        คาสิโนออนไลน์ ที่ดีที่สุด<br>ต้องพัฒนาอย่างใส่ใจทุกคลิ๊ก
                      </h4>
                      <h4 class="-content">
                        บาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด
                        เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง แบบ Casino
                      </h4>
                    </div>
                    <div class="-banner-icon-wrapper">
                      <img
                        src="@/assets/newImg/ico/ระบบแรงกว่ามาตรฐานสากล-3-เท่า.png"
                        alt="ระบบคาสิโนปลอดภัย แรงกว่ามาตรฐาน 3 เท่า"
                        data-animatable="fadeInUp"
                        data-delay="200"
                        class="-ic-banner animated fadeInUp"
                      ><img
                        src="@/assets/newImg/ico/ฝ่ายบริการลูกค้า-24-7-ชม.png"
                        alt="คาสิโนออนไลน์ที่บริการลูกค้า 24 ชม."
                        data-animatable="fadeInUp"
                        data-delay="400"
                        class="-ic-banner animated fadeInUp"
                      ><img
                        src="@/assets/newImg/ico/ระบบฝากถอนเงินออโต้-อัตโนมัติ.png"
                        alt="ฝากถอนเงิน และเครดิตฟรีอัตโนมัติ"
                        data-animatable="fadeInUp"
                        data-delay="600"
                        class="-ic-banner animated fadeInUp"
                      >
                    </div>
                  </div>
                  <div
                    class="-tag-wrapper d-none d-lg-block d-xl-block d-xxl-block"
                  >
                    <div class="-content-wrapper">
                      <div
                        class="-title"
                        :style="{
                          color: data.title_color ? data.title_color.hex : '',
                        }"
                      >
                        TAG
                      </div>
                      <div class="container x-footer-seo">
                        <div class="-tags">
                          <a
                            href="/"
                            class="btn"
                          > casino online</a><a
                            href="/"
                            class="btn"
                          > บาคาร่า</a><a
                            href="/"
                            class="btn"
                          > คาสิโน</a><a
                            href="/"
                            class="btn"
                          > gamecasino</a><a
                            href="/"
                            class="btn"
                          > ออนไลน์ คาสิโน</a><a
                            href="/"
                            class="btn"
                          > game casino</a><a
                            href="/"
                            class="btn"
                          > ae sexy</a><a
                            href="/"
                            class="btn"
                          > เว็บคาสิโน</a><a
                            href="/"
                            class="btn"
                          > ป๊อก เด้ง</a><a
                            href="/"
                            class="btn"
                          > dg casino</a><a
                            href="/"
                            class="btn"
                          > wm casino</a><a
                            href="/"
                            class="btn"
                          > allbet</a><a
                            href="/"
                            class="btn"
                          > sexy gaming</a><a
                            href="/"
                            class="btn"
                          > sa gaming</a><a
                            href="/"
                            class="btn"
                          > คาสิโนออนไลน์</a><a
                            href="/"
                            class="btn"
                          > บาคาร่าสด</a><a
                            href="/"
                            class="btn"
                          > เครดิตฟรี</a><a
                            href="/"
                            class="btn"
                          > บาคาร่า</a><a
                            href="/"
                            class="btn"
                          > เสือ มังกร</a><a
                            href="/"
                            class="btn"
                          > บาคาร่าออนไลน์</a><a
                            href="/"
                            class="btn"
                          > เกมไพ่</a><a
                            href="/"
                            class="btn"
                          > sagame</a><a
                            href="/"
                            class="btn"
                          > คาสิโน</a><a
                            href="/"
                            class="btn"
                          > casino</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="-provider-wrapper">
                    <div class="-content-wrapper -payments">
                      <div
                        class="-title"
                        :style="{
                          color: data.title_color ? data.title_color.hex : '',
                        }"
                      >
                        PAYMENTS ACCEPTED
                      </div>
                      <div class="x-footer-banner-provider">
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/bbl.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/kbank.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/ktb.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/tmb.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/scb.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/cimb.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/uob.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/bay.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/gsb.png"
                          >
                        </div>
                        <div class="-image-wrapper ng-star-inserted">
                          <img
                            alt="CasinoPayments Accepted bay"
                            width="50"
                            height="50"
                            class="-logo-ic img-fluid rounded-circle"
                            src="https://cdn.karnival.cloud/Images/bank/BAAC.png"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="-footer-bottom-wrapper">
                  <div class="row justify-content-center">
                    <div class="col-md-6 text-center mt-4">
                      Created website by Power100th
                      <div class="text-center ng-star-inserted">
                        <a
                          href="https://karnival.cloud"
                          target="_blank"
                          rel="nofollow noopener"
                          class="-img-wrap -img-wrap-link text-decoration-none"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <a
                      href="/term-and-condition"
                      target="_blank"
                      class="-term-btn"
                    >
                      Terms and Conditions
                    </a>
                  </div>
                  <div>
                    <p class="mb-0">
                      Copyright © 2021 All Rights Reserved.
                    </p>
                    <p class="opacity-50 ng-star-inserted">
                      <small>(11aax)</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-sidebar
      id="sidebar-right"
      body-class=""
      header-class="no-header"
      bg-variant=""
      right
      no-header
      shadow
    >
      <div
        class="x-modal-account-menu-mobile h-100 pl-2 pr-2 pt-2"
        :style="{ background: data.drawer_color ? data.drawer_color.hex : '' }"
      >
        <div class="-modal-profile-mobile">
          <div class="x-profile-image ng-star-inserted text-center">
            <img
              src="@/assets/newImg/profile.jpg"
              alt="customer image"
              width="60"
              height="60"
              class="img-fluid -profile-image rounded-circle border border-2"
            >
          </div>

          <div class="-balance-containers ng-star-inserted text-center">
            <div class="-text-username text-white">
              power1231231231
            </div>
            <div class="-user-balance js-user-balance f-sm-6 f-7 text-white">
              <div class="-inner-box-wrapper">
                <img
                  src="@/assets/newImg/ic-coin.png"
                  alt="customer image"
                  width="26"
                  height="21"
                  class="img-fluid -ic-coin"
                ><span id="customer-balance">0.0</span>
              </div>
              <!-- <button
                id="btn-customer-balance-reload"
                type="button"
                class="-btn-balance"
              >
                <i class="fas fa-sync-alt f-9" />
              </button> -->
            </div>
            <div class="-user-balance js-user-balance f-sm-6 f-7">
              <div class="-inner-box-wrapper">
                <span id="customer-balance"> เทิร์นที่ต้องทำ / </span>
                <span id="customer-balance"> เทิร์นที่ทำ</span>
              </div>
            </div>
          </div>
        </div>
        <div class="-lists-outer-wrapper">
          <ul class="navbar-navs">
            <li
              class="nav-item ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'home' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/home.png"
                    alt="ic-menu-user"
                    class="-icon-image"
                    height="35"
                  ><span class="-text-menu"> หน้าหลัก </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'profile' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/ic-menu-user.png"
                    alt="ic-menu-user"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> ข้อมูลบัญชี </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -coupon ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'deposit-fixed' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar js-account-approve-aware"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/depo.png"
                    alt="ic-menu-coupon"
                    width="35px"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> ฝากประจำ </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -coupon ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'invite-friend' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar js-account-approve-aware"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/affiliate.png"
                    alt="ic-menu-coupon"
                    width="35px"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> สร้างรายได้ </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -join-promotion ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'promotions' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/ic-header-menu-promotion.png"
                    width="35"
                    alt="ic-menu-promotion"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> โปรโมชั่น </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -join-promotion ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'lucky-wheel' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/wheel.png"
                    width="35"
                    alt="ic-menu-promotion"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> หมุนกงล้อ </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -join-promotion ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'deposit' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/ic-mobile-right-1.webp"
                    alt="ic-menu-promotion"
                    width="35"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> ฝากเงิน </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -join-promotion ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <router-link :to="{ name: 'withdraw' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/ic-mobile-right-2.webp"
                    alt="ic-menu-promotion"
                    width="35"
                    class="img-fluid -icon-image"
                  ><span class="-text-menu"> ถอนเงิน </span>
                </button>
              </router-link>
            </li>
            <li
              class="nav-item -logout ng-star-inserted"
              :style="{
                background: data.drawer_button_color
                  ? data.drawer_button_color.hex
                  : '',
              }"
            >
              <button
                type="button"
                class="nav-links js-close-account-sidebar"
              >
                <img
                  src="@/assets/newImg/ic-menu-logout.png"
                  alt="ic-menu-logout"
                  class="img-fluid -icon-image"
                ><span class="-text-menu"> ออกจากระบบ </span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { BImg, BSidebar, VBToggle } from 'bootstrap-vue'
import 'swiper/css/swiper.css'

export default {
  components: {
    BImg,
    Swiper,
    SwiperSlide,
    BSidebar,
    VBToggle,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: ['data'],
  data: () => ({
    swiperOptions: {
      effect: 'fade',
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    },
    gameList: [],
    gameListOp: [
      /* eslint-disable global-require */
      {
        icon: require('@/assets/newImg/slot.png'),
        name_th: 'สล็อตเกม',
        name_en: 'SLOT',
        alt: 'สล็อตเกม',
        cat: 'EGAMES',
      },
      {
        icon: require('@/assets/newImg/คาสิโนออนไลน์-บาคาร่าสด-รูเล็ต-ซิคโบ-ไฮโล-เสือ-มังกร.png'),
        name_th: 'คาสิโนสด',
        name_en: 'CASINO',
        alt: 'คาสิโนสด',
        cat: 'LIVECASINO',
      },
      {
        icon: require('@/assets/newImg/แทงฟุตบอลพนันออนไลน์-บาสเก็ตบอล-E-Sport.png'),
        name_th: 'กีฬา',
        name_en: 'SPORT',
        alt: 'กีฬา',
        cat: 'SPORT',
      },
      {
        icon: require('@/assets/newImg/lotto.png'),
        name_th: 'หวย',
        name_en: 'LOTTO',
        alt: 'หวย',
        cat: 'LOTTO',
      },
      {
        icon: require('@/assets/newImg/quick-nav-mpg.png'),
        name_th: 'ยิงปลา',
        name_en: 'FISHING',
        alt: 'ยิงปลา',
        cat: 'FISHING',
      },
      {
        icon: require('@/assets/newImg/poker.png'),
        name_th: 'เกมการ์ด',
        name_en: 'G-CARD',
        alt: 'เกมการ์ด',
        cat: 'CARD',
      },
      {
        icon: require('@/assets/newImg/poker.png'),
        name_th: 'เกมโป๊กเกอร์',
        name_en: 'POKER',
        alt: 'โป๊กเกอร์',
        cat: 'POKER',
      },
      {
        icon: require('@/assets/newImg/trading.png'),
        name_th: 'เทรดดิ้ง',
        name_en: 'TRADING',
        alt: 'เทรดดิ้ง',
        cat: 'TRADING',
      },
      /* eslint-disable global-require */
    ],
  }),
}
</script>

<style>
.x-header .-menu-wrapper .nav-link {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  min-width: 90px;
  height: calc(100% + 5px);
  padding: 0.5rem;
  text-align: center;
  color: #f2f2f2;
  background: linear-gradient(
    180deg,
    rgba(43, 67, 129, 0.96) 0.02%,
    rgba(31, 10, 90, 0.96) 99.96%
  );
  transition: 0.3s;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
[dir="ltr"] .x-header .-menu-wrapper .nav-item:not(:last-child) .nav-link {
  margin-right: 0.5rem;
}

.x-footer .-footer-wrapper {
  display: flex;
  flex-direction: column;
  background-color: #232323;
  padding: 0;
}

@media (max-width: 991.98px) {
  .x-footer .-footer-wrapper {
    padding-bottom: 100px;
  }
}

@media (max-width: 767.98px) {
  .x-footer .-footer-wrapper {
    background-color: transparent;
  }
}

.x-footer .-footer-inner-wrapper {
  display: flex;
  justify-content: space-evenly;
  transition: all 0.4s;
  padding: 2rem 1rem;
}

@media (max-width: 1480px) {
  .x-footer .-footer-inner-wrapper {
    justify-content: space-between;
  }
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper {
    justify-content: center;
    flex-wrap: wrap;
  }
}

@media (max-width: 991.98px) {
  .x-footer .-footer-inner-wrapper {
    padding: 2rem 0;
  }
}

.x-footer .-footer-inner-wrapper .-describe-wrapper {
  flex: 0 0 24%;
  min-width: 300px;
  transition: all 0.4s;
}

@media (max-width: 1480px) {
  .x-footer .-footer-inner-wrapper .-describe-wrapper {
    margin: 0 auto;
  }
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-describe-wrapper {
    flex: 0 0 80%;
    align-items: center;
  }
}

@media (max-width: 767.98px) {
  .x-footer .-footer-inner-wrapper .-describe-wrapper {
    flex: 0 0 100%;
  }
}

.x-footer .-footer-inner-wrapper .-describe-wrapper .-content-wrapper {
  padding: 0 1rem;
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-describe-wrapper .-content-wrapper {
    text-align: center;
  }
}

.x-footer
  .-footer-inner-wrapper
  .-describe-wrapper
  .-content-wrapper
  .-content {
  margin-bottom: 1rem;
}

.x-footer .-footer-inner-wrapper .-describe-wrapper .-banner-icon-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 0 1rem;
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-describe-wrapper .-banner-icon-wrapper {
    justify-content: center;
  }
}

.x-footer
  .-footer-inner-wrapper
  .-describe-wrapper
  .-banner-icon-wrapper
  .-ic-banner {
  width: calc(33.33333% - 5px);
}

@media (max-width: 1199.98px) {
  .x-footer
    .-footer-inner-wrapper
    .-describe-wrapper
    .-banner-icon-wrapper
    .-ic-banner {
    width: 110px;
    margin-right: 0.5rem;
  }
}

@media (max-width: 991.98px) {
  .x-footer
    .-footer-inner-wrapper
    .-describe-wrapper
    .-banner-icon-wrapper
    .-ic-banner {
    width: 95px;
  }

  .x-footer
    .-footer-inner-wrapper
    .-describe-wrapper
    .-banner-icon-wrapper
    .-ic-banner:last-child {
    margin-right: 0;
  }
}

@media (max-width: 375px) {
  .x-footer
    .-footer-inner-wrapper
    .-describe-wrapper
    .-banner-icon-wrapper
    .-ic-banner {
    width: 86px;
  }
}

.x-footer .-footer-inner-wrapper .-tag-wrapper {
  flex-grow: 1;
  transition: all 0.4s;
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-tag-wrapper {
    margin-top: 1rem;
  }
}

.x-footer .-footer-inner-wrapper .-provider-wrapper {
  display: flex;
  flex: 0 0 23%;
  flex-direction: column;
  transition: all 0.4s;
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-provider-wrapper .-partnership {
    margin-top: 1rem;
  }
}

@media (min-width: 768px) {
  .x-footer .-footer-inner-wrapper .-provider-wrapper .-payments {
    margin-top: 2rem;
  }
}

@media (max-width: 767.98px) {
  .x-footer .-footer-inner-wrapper .-provider-wrapper .-payments {
    margin-top: 1rem;
  }
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-provider-wrapper {
    flex: 0 0 80%;
  }
}

@media (max-width: 767.98px) {
  .x-footer .-footer-inner-wrapper .-provider-wrapper {
    flex: 0 0 100%;
  }
}

.x-footer .-footer-inner-wrapper .-content-wrapper {
  padding: 0 1rem;
}

@media (max-width: 1199.98px) {
  .x-footer .-footer-inner-wrapper .-content-wrapper {
    text-align: center;
  }
}

.x-footer .-footer-inner-wrapper .-content-wrapper .-title {
  color: var(--bg-hover-1);
  font-size: 1.125rem;
  font-weight: 200;
  line-height: 1.5;
}

@media (min-width: 1200px) and (max-width: 1480px) {
  .x-footer .-footer-inner-wrapper .-content-wrapper .-title {
    font-size: 1rem;
  }
}

@media (max-width: 575.98px) {
  .x-footer .-footer-inner-wrapper .-content-wrapper .-title {
    margin-bottom: 0.75rem;
  }
}

.x-footer .-footer-inner-wrapper .-content-wrapper .-content {
  margin-top: 0.25rem;
  font-size: 1rem;
  font-weight: 200;
  line-height: 1.5;
}

@media (min-width: 1200px) and (max-width: 1480px) {
  .x-footer .-footer-inner-wrapper .-content-wrapper .-content {
    font-size: 1rem;
  }
}

.x-footer .-footer-bottom-wrapper {
  padding-bottom: 0.75rem;
  text-align: center;
}

.x-footer .-footer-bottom-wrapper .-term-btn {
  color: var(--bg-hover-1);
}

.x-footer-seo {
  padding: 0;
  margin: 0.25rem 0;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .x-footer-seo {
    max-width: 100%;
  }
}

@media (max-width: 767.98px) {
  .x-footer-seo {
    margin: 0.25rem auto;
  }
}

.x-footer-seo .-tags {
  border-bottom: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.x-footer-seo .-tags .btn {
  font-size: 0.875rem;
  color: #fbfbfb;
  margin-bottom: 6px;
  margin-right: 6px;
  padding: 5px 15px;
  border-radius: 18px;
  background: #464646;
  transition: all 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .x-footer-seo .-tags .btn {
    transition: none;
  }
}

.x-footer-seo .-tags .btn:hover {
  background: #595959;
}

@media (min-width: 1200px) and (max-width: 1480px) {
  .x-footer-seo .-tags .btn {
    padding: 5px 10px;
    font-size: 0.8rem;
  }
}

@media (max-width: 1199.98px) {
  .x-footer-seo .-tags {
    justify-content: center;
  }
}

.x-footer-banner-provider {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 0.25rem;
}

@media (max-width: 1199.98px) {
  .x-footer-banner-provider {
    width: 90%;
    margin: auto;
    justify-content: center;
  }
}

@media (max-width: 767.98px) {
  .x-footer-banner-provider {
    width: 100%;
  }
}

.x-footer-banner-provider .-image-wrapper {
  text-align: center;
  padding: 0.25rem;
}

.x-footer-banner-provider .-image-wrapper .-logo-ic {
  width: 40px;
  height: auto;
}

@media (max-width: 767.98px) {
  .x-footer-banner-provider .-image-wrapper {
    flex: 0 0 auto;
  }
}

@media (max-width: 575.98px) {
  .x-footer-banner-provider .-image-wrapper {
    padding: 0.15rem;
  }
}
.x-landing .x-footer {
  background: transparent;
  position: relative;
}

.x-landing .x-footer:before {
  content: "";
  position: absolute;
  background: linear-gradient(
    90deg,
    rgba(235, 119, 207, 0),
    #dc76d4 39.87%,
    #9972ea 60.18%,
    rgba(130, 113, 242, 0)
  );
  width: 100%;
  height: 5px;
  top: 0;
}

@media (max-width: 991.98px) {
  .x-landing .x-footer .-copy-right-container {
    padding: 0.5rem 0 40px;
  }
}

.x-footer-seo {
  padding: 0;
  margin: 0.25rem 0;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .x-footer-seo {
    max-width: 100%;
  }
}

@media (max-width: 767.98px) {
  .x-footer-seo {
    margin: 0.25rem auto;
  }
}

.x-footer-seo .-tags {
  border-bottom: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.x-footer-seo .-tags .btn {
  font-size: 0.875rem;
  color: #fbfbfb;
  margin-bottom: 6px;
  margin-right: 6px;
  padding: 5px 15px;
  border-radius: 18px !important;
  background: #464646;
  transition: all 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .x-footer-seo .-tags .btn {
    transition: none;
  }
}

.x-footer-seo .-tags .btn:hover {
  background: #595959;
}

@media (min-width: 1200px) and (max-width: 1480px) {
  .x-footer-seo .-tags .btn {
    padding: 5px 10px;
    font-size: 0.8rem;
  }
}

@media (max-width: 1199.98px) {
  .x-footer-seo .-tags {
    justify-content: center;
  }
}

.x-hamburger {
  margin-right: 15px;
  width: 25px;
  height: 24px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

@media (max-width: 991.98px) {
  .x-hamburger {
    margin-right: 10px;
  }
}

@media (max-width: 575.98px) {
  .x-hamburger {
    width: 20px;
  }
}

.x-hamburger span {
  width: 70%;
  display: block;
  position: absolute;
  height: 3px;
  background: #fff;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}

.x-hamburger span:first-child {
  top: 0;
  animation: x-hamburger-wave 0.4s ease-out infinite alternate;
}

.x-hamburger span:first-child,
.x-hamburger span:nth-child(2) {
  transform-origin: left center;
}

.x-hamburger span:nth-child(2) {
  top: 9px;
  animation: x-hamburger-wave 0.4s ease-out 0.3s infinite alternate;
}

.x-hamburger span:nth-child(3) {
  top: 18px;
  transform-origin: left center;
  animation: x-hamburger-wave 0.4s ease-out 0.6s infinite alternate;
}

@media (max-width: 575.98px) {
  .x-hamburger span:nth-child(2) {
    top: 7px;
  }

  .x-hamburger span:nth-child(3) {
    top: 14px;
  }
}

.x-hamburger.-open {
  width: 25px;
}

.x-hamburger.-open span {
  width: 100%;
  animation: none;
}

.x-hamburger.-open span:first-child {
  transform: rotate(45deg);
  top: 0;
  left: 5px;
}

.x-hamburger.-open span:nth-child(2) {
  width: 0;
  opacity: 0;
}

.x-hamburger.-open span:nth-child(3) {
  transform: rotate(-45deg);
  top: 18px;
  left: 5px;
}

@media (max-width: 575.98px) {
  .x-hamburger.-open {
    width: 20px;
  }

  .x-hamburger.-open span:nth-child(3) {
    top: 15px;
  }
}
.b-sidebar-outer {
  position: absolute !important;
}

.b-sidebar {
  position: absolute !important;
}

.x-menu-account-list-sidebar
  .x-modal-account-menu-mobile
  .navbar-nav
  .nav-item {
  margin-bottom: 0.5rem;
  border-radius: 14px;
  background: var(--bg-x-feed);
}

.-lists-outer-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.b-sidebar.b-sidebar-right {
  left: auto;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(43, 67, 129, 0.96) 0.02%,
    rgba(31, 10, 90, 0.96) 99.96%
  );
}

.navbar-navs .nav-item .nav-links {
  padding: 0.8rem 1.2rem 0.75rem;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.-user-balance {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.1rem 0.5rem 0.2rem 1.75rem;
  background: #424867;
  border-radius: 30px;
}

.nav-item button {
  width: 100%;
  background-color: transparent !important;
  border: none;
}

.navbar-navs .nav-item {
  margin-bottom: 0.5rem;
  border-radius: 14px;
  background: #1b2341;
}

.-text-menu {
  color: #f2f2f2;
  transition: color 0.3s;
  margin: auto 0 auto 0.75rem;
}

.navbar-navs {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-navs {
  width: 100%;
  margin-top: 1rem;
  flex-direction: column;
}

.-balance-container .-user-balance {
  margin-top: 0.5rem;
  margin-right: 0;
  padding: 0.25rem 0.5rem 0.25rem 2.2rem;
  background: #424867;
}

@media (max-width: 991.98px) {
  .-user-balance {
    padding: 0;
    background: transparent;
  }
}

.navbar-navs .nav-item .nav-links {
  padding: 0.8rem 1.2rem 0.75rem;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.-user-balance {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.1rem 0.5rem 0.2rem 1.75rem;
  background: #424867;
  border-radius: 30px;
}

.-balance-containers {
  flex-direction: column;
  color: #f2f2f2;
  padding: 0.25rem 0;
  margin: auto 0;
}

.-balance-containers {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
